/** @format */

import React from "react";
import {
	BannerTwo,
	BusinessTeaser,
	CircleHero,
	CircleStickyCTA,
	CircleVisualization,
	Footer,
	GeneralTab,
	HowItWorks,
	MemberSection,
	ScrollRevealScope,
	SEO,
	SocialProof,
	SupportedCountriesSection,
	TrustQuestions,
	WhySafer,
} from "../allComponents/AllComponents";

const Home = () => {
	return (
		<>
			<SEO
				title="Savings Circles | Save Together, Pay Out Fairly"
				description="FundsyFi Circles lets trusted groups run savings circles online with automated contributions, rotating payouts, identity-verified members, and transparent tracking."
				url="/circle"
			/>

			<CircleHero />

			{/* Order follows the conversion path: grasp it → see it → trust it → join. */}
			<ScrollRevealScope>
				<HowItWorks />

				<CircleVisualization />

				<BannerTwo />

				<WhySafer />

				<SocialProof />

				<TrustQuestions />

				<SupportedCountriesSection />

				<MemberSection />

				<GeneralTab />

				<BusinessTeaser />
			</ScrollRevealScope>

			<CircleStickyCTA />

			<Footer />
		</>
	);
};

export default Home;
